import React from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";

export default function AdaptersCreateBreadcrumb() {
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  const navigateToAdapters = () => {
    navigate({
      pathname: "/edge-management/adapters",
    });
  };

  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.edgeManagement")}</Breadcrumb.Item>
      <Breadcrumb.Item
        onClick={() => {
          navigateToAdapters();
        }}
        className="generalStyles__breadcrumbItemInactive"
      >
        {t("header.adapters")}
      </Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {t("adapter.createNewAdapter")}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}
